<template>
    <div class="cointainer">
        <!-- Button to open the Member Registration modal 
        <b-button @click="openAgentMemberRegisterModal">Launch Member Registration</b-button>
        -->

        <!-- Modal component -->
        <b-modal id="agentMemberRegisterModal" :title="modals.memberRegistration" @ok="handleModalOkClick" @hidden="reset" size="lg"  ok-title="受講生登録" cancel-title="キャンセル" modal-class="agent-netenglish-modal">

            <div v-if="isSuccess == true" class="text-center">
                <div class="alert alert-success" role="alert">
                    {{ this.message }}
                </div>
            </div>

            <form @submit.prevent="submitForm" autocomplete="off">

                <!-- Email Address -->
                <b-form-group label-class="small" :label="labels.email" label-for="email"
                    :invalid-feedback="formErrors.email">
                    <b-form-input type="email" id="email" v-model="form.email" :state="formErrors.email ? false : null"
                        required size="sm" @input="validateField('email')"></b-form-input>
                </b-form-group>

                <b-row>
                    <!-- Japanese Last Name (姓) -->
                    <b-col md="6">
                        <b-form-group label-class="small" :label="labels.japaneseLastName" label-for="japaneseLastName"
                            :invalid-feedback="formErrors.japaneseLastName">
                            <b-form-input id="japaneseLastName" v-model="form.japaneseLastName"
                                :state="formErrors.japaneseLastName ? false : null" required size="sm"
                                @input="validateField('japaneseLastName')"></b-form-input>
                        </b-form-group>
                    </b-col>

                    <!-- Japanese First Name (名) -->
                    <b-col md="6">
                        <b-form-group label-class="small" :label="labels.japaneseFirstName" label-for="japaneseFirstName"
                            :invalid-feedback="formErrors.japaneseFirstName">
                            <b-form-input id="japaneseFirstName" v-model="form.japaneseFirstName"
                                :state="formErrors.japaneseFirstName ? false : null" required size="sm"
                                @input="validateField('japaneseFirstName')"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <!-- Last Name (姓・ローマ字) -->
                    <b-col md="6">
                        <b-form-group label-class="small" :label="labels.lastName" label-for="lastName"
                            :invalid-feedback="formErrors.lastName">
                            <b-form-input id="lastName" v-model="form.lastName"
                                :state="formErrors.lastName ? false : null" required size="sm"
                                @input="validateField('lastName')"></b-form-input>
                        </b-form-group>
                    </b-col>

                    <!-- First Name (名・ローマ字) -->
                    <b-col md="6">
                        <b-form-group label-class="small" :label="labels.firstName" label-for="firstName"
                            :invalid-feedback="formErrors.firstName">
                            <b-form-input id="firstName" v-model="form.firstName"
                                :state="formErrors.firstName ? false : null" required size="sm"
                                @input="validateField('firstName')"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <!-- Attribute (Trial, Member, Withdraw) (EXCLUDED)
                <b-row>
                    
                    <b-col md="6">
                        <b-form-group label-class="small" :label="labels.attribute" label-for="attribute"
                            :invalid-feedback="formErrors.attribute">
                            <b-form-select id="attribute" v-model="form.attribute"
                                :state="formErrors.attribute ? false : null" required size="sm"
                                @input="validateField('attribute')">
                                <b-form-select-option value="trial">Trial</b-form-select-option>
                                <b-form-select-option value="member">Member</b-form-select-option>
                                <b-form-select-option value="withdraw">Withdraw</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                -->

                <!-- Nickname -->
                <b-form-group label-class="small" :label="labels.nickname" label-for="nickname" :invalid-feedback="formErrors.nickname">
                    <b-form-input id="nickname" v-model="form.nickname" :state="formErrors.nickname ? false : null"
                        required size="sm" @input="validateField('nickname')"></b-form-input>
                </b-form-group>

                <b-row>
                    <!-- Gender -->
                    <b-col md="6">

                        <b-form-group label-class="small">
                            <label class="small">{{ labels.gender }}</label>
                            <b-form-radio-group 
                                v-model="form.gender" 
                                :state="formErrors.gender ? false : null" 
                                required 
                                size="sm" 
                                @input="validateField('gender')"
                            >
                                <b-form-radio value="male" class="small">Male</b-form-radio>
                                <b-form-radio value="female" class="small">Female</b-form-radio>
                            </b-form-radio-group>
                            <b-form-invalid-feedback v-if="formErrors.gender">
                                {{ formErrors.gender }}
                            </b-form-invalid-feedback>
                        </b-form-group>                        

                    </b-col>
                </b-row>

                <b-form-group label-class="small">
                   
                    <b-row>
                        <!-- Communication App Selection -->
                        <b-col md="6">
                            <label :class="'small'">
                               
                                <span>{{ labels.communicationApp }}</span>

                                <a href="https://net-english.study/pages/gmailzoom" class="esiModal">{{ '(ZOOM(推奨' }}</a>
                                <span>or</span>
                                <a href="https://net-english.study/pages/gmailteams" class="esiModal">{{ 'Teams)' }}</a>
                              
                            </label>

                            <b-input-group size="sm">
                                <b-form-select 
                                v-model="form.communicationApp" 
                                :state="formErrors.communicationApp ? false : null" 
                                required 
                                size="sm"
                                @input="validateField('communicationApp')"
                                >
                                <b-form-select-option value="msteams">MSTeams</b-form-select-option>
                                <b-form-select-option value="zoom">Zoom</b-form-select-option>                               
                                </b-form-select>
                                <b-form-invalid-feedback v-if="formErrors.communicationApp">
                                    {{ formErrors.communicationApp }}
                                </b-form-invalid-feedback>
                            </b-input-group>
                        </b-col>

                        <!-- Communication Username Input -->
                        <b-col md="6">

                            <label :class="'small'">
                                <a href="https://net-english.study/pages/teams-zoom-id" class="esiModal">{{ labels.communicationUsername }}</a>
                            </label>

                            <b-input-group size="sm">
                                <b-form-input 
                                    :placeholder="labels.communicationUsername" 
                                    v-model="form.communicationUsername"
                                    :state="formErrors.communicationUsername ? false : null" 
                                    required 
                                    size="sm"
                                    @input="validateField('communicationUsername')"
                                />
                                <b-form-invalid-feedback v-if="formErrors.communicationUsername">
                                {{ formErrors.communicationUsername }}
                                </b-form-invalid-feedback>
                            </b-input-group>
                        </b-col>
                    </b-row>
                </b-form-group>


                <b-row>
                    <b-col md="6">
                        <!-- Password -->
                        <b-form-group label-class="small" :label="labels.password" label-for="password"
                            :invalid-feedback="formErrors.password">
                            <b-form-input type="password" id="password" v-model="form.password" autocomplete="new-password"
                                :state="formErrors.password ? false : null" required size="sm"></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <!-- Confirm Password -->
                        <b-form-group label-class="small" :label="labels.confirmPassword" label-for="confirmPassword"
                            :invalid-feedback="formErrors.confirmPassword">
                            <b-form-input type="password" id="confirmPassword" v-model="form.confirmPassword"
                                :state="formErrors.confirmPassword ? false : null" required size="sm"
                                @input="validateField('confirmPassword')"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

            </form>
        </b-modal>
    </div>
</template>




<script>
export default {
    props: {
        memberships: Array,
        csrf_token: String,
        api_token: String,
        agent_info: Object,
        agent_user_id: Number,
    },
    data() {
        return {
            modals: {
                memberRegistration: '受講生登録'
            },
            isLoading: false,
            isSuccess: false,     
            message: '',                   
            form: {
                email: '',
                japaneseLastName: '',
                japaneseFirstName: '',
                firstName: '',
                lastName: '',
                //attribute: '',
                nickname: '',
                gender: '',
                communicationApp: '',
                communicationUsername: '',
                password: '',
                confirmPassword: ''
            },
            formErrors: {
                email: null,
                japaneseLastName: null,
                japaneseFirstName: null,
                firstName: null,
                lastName: null,
                //attribute: null,
                nickname: null,
                gender: null,
                communicationApp: null,
                communicationUsername: null,
                password: null,
                confirmPassword: null
            },
           
            fieldNamesEN: {
                email: 'Email Address',
                japaneseLastName: 'Japanese Last Name',
                japaneseFirstName: 'Japanese First Name',
                firstName: 'First Name',
                lastName: 'Last Name',
                //attribute: 'Attribute',
                nickname: 'Nickname',
                gender: 'Gender',
                communicationApp: 'Communication App',
                communicationUsername: 'Communication Username',
                password: 'Password',
                confirmPassword: 'Confirm Password'
            },
            fieldNames: {
                email: 'メールアドレス',
                japaneseLastName: '姓',
                japaneseFirstName: '名',
                firstName: '名（ローマ字）',
                lastName: '姓（ローマ字）',
                nickname: 'ニックネーム（ローマ字）講師が呼びやすいネーム（例：ファ-ストネーム)',
                gender: '性別',
                communicationApp: '通信アプリ',
                communicationUsername: '通信アプリのID',
                password: 'パスワード',
                confirmPassword: 'パスワードを認証する'  
            },            
            
            labels: {
                email: 'メールアドレス',
                japaneseLastName: '姓',
                japaneseFirstName: '名',
                firstName: '名（ローマ字）',
                lastName: '姓（ローマ字）',
                nickname: 'ニックネーム（ローマ字）講師が呼びやすいネーム（例：ファ-ストネーム)',
                gender: '性別',
                communicationApp: '通信アプリ',
                communicationUsername: '通信アプリのID',
                password: 'パスワード',
                confirmPassword: 'パスワードを認証する'                
            }
        };
    },
    mounted() {
        window.openAgentMemberRegisterModal = this.openAgentMemberRegisterModal;
    },
    methods: {
        reset() {
            this.isLoading = false;
            this.isSuccess = false;     
            this.message = '';
            this.form = {
                email: '',
                japaneseLastName: '',
                japaneseFirstName: '',
                firstName: '',
                lastName: '',
                nickname: '',
                gender: '',
                communicationApp: '',
                communicationUsername: '',
                password: '',
                confirmPassword: ''
            };

            this.formErrors = {
                email: null,
                japaneseLastName: null,
                japaneseFirstName: null,
                firstName: null,
                lastName: null,
                //attribute: null,
                nickname: null,
                gender: null,
                communicationApp: null,
                communicationUsername: null,
                password: null,
                confirmPassword: null
            }
           
        },
        validateForm() {
            let isValid = true;
            Object.keys(this.form).forEach(field => {
                if (!this.form[field]) {
                    this.$set(this.formErrors, field, `${this.fieldNames[field]} が必要です`);
                    isValid = false;
                }
            });
            return isValid;
        },
        validateField(fieldName) {
            // Reset the error for the field being validated
            this.$set(this.formErrors, fieldName, null);

            // Check if the field is empty
            if (!this.form[fieldName]) {
                this.$set(this.formErrors, fieldName, `${this.fieldNames[fieldName]} が必要です`);
            }

            // Email validation
            if (fieldName === 'email') {
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailPattern.test(this.form.email)) {
                    this.$set(this.formErrors, 'email', '有効なメールアドレスを入力してください');
                }
            }

            // Confirm Password validation
            if (fieldName === 'password' || fieldName === 'confirmPassword') {
                if (this.form.password !== this.form.confirmPassword) {
                    this.$set(this.formErrors, 'confirmPassword', 'パスワードが一致しません');
                }
            }
        },
        openAgentMemberRegisterModal() 
        {              
            this.$bvModal.show('agentMemberRegisterModal');
        },
        closeAgentMemberRegisterModal() {          
            this.$bvModal.hide('agentMemberRegisterModal');
            this.reset();
        },        
        handleModalOkClick($event) {
            // Prevent the modal from closing when the OK button is pressed
            $event.preventDefault();  // This prevents the default close behavior of the modal
            this.submitForm();        // Call your form submission logic
        },
        submitForm() {
            
            if (this.validateForm()) {

                //initialize attribute to member (Default for AGENT)
                this.form.attribute = 'member';                

                axios.post("/api/create_agent_member?api_token=" + this.api_token, {
                    method: "POST",
                    form: JSON.stringify(this.form),
                    agent_user_id: this.$props.agent_user_id,
                }).then(response => {
                    console.log(response)
                    if (response.data.success === false) {
                        alert(response.data.message);
                    } else {                       
                        this.isSuccess = true;
                        this.message = response.data.message;
                        setTimeout(() => {                           
                            this.closeAgentMemberRegisterModal();
                            this.reset();
                        }, 2500);
                    }

                }).catch(function (error) {
                    alert("Error " + error);
                });
            }
        },

    }
};
</script>